/**
 * Fifth Effect Custom JavaScript
 * Extends theme functionality without modifying core files
 * @version 1.0.0
 */

(function() {
  'use strict';

  /**
   * Extends QtyBreak to add total price to Add to Cart button
   * Adds updateAddToCartButtonText method to update button with selected quantity price
   */
  function extendQtyBreak() {
    // Wait for the custom element to be defined
    customElements.whenDefined('qty-break').then(() => {
      const QtyBreakPrototype = customElements.get('qty-break').prototype;
      
      /**
       * Fifth Effect Custom: Updates Add to Cart button text with total price
       * Updates ALL Add to Cart buttons on the page (main form + sections)
       * @param {HTMLElement} selectedButton - The selected quantity button
       */
      QtyBreakPrototype.updateAddToCartButtonText = function(selectedButton) {
        const totalPriceElement = selectedButton.querySelector('.quantity-total-price');
        const totalPrice = totalPriceElement ? totalPriceElement.innerText : '';
        
        if (totalPrice) {
          // Find ALL Add to Cart buttons on the page (main form + sections)
          const qtyBreakButton = this.customParentElement.querySelector('.main-product-form .product-form button.product-form__btn');
          const addToCartButtons = document.querySelectorAll(`button[data-product-id="${qtyBreakButton.dataset.productId}"].product-form__btn span[data-button-text], button[data-related-product-id="${qtyBreakButton.dataset.productId}"]`);
          
          addToCartButtons.forEach(btn => {
            // Only update if it's not a sold out or pre-order button
            const currentText = btn.innerText.trim();
            let baseText = '';
            let shouldUpdate = false;
            
            // Determine base text and whether to update
            if (currentText.includes('ADD TO CART')) {
              baseText = 'ADD TO CART';
              shouldUpdate = true;
            } else if (currentText.includes('START SUBSCRIPTION')) {
              baseText = 'START SUBSCRIPTION';
              shouldUpdate = true;
            }
            
            if (shouldUpdate) {
              btn.innerText = `${baseText} - ${totalPrice}`;
            }
          });
        }
      };

      // Store original handleButtonClick
      const originalHandleButtonClick = QtyBreakPrototype.handleButtonClick;
      
      /**
       * Override handleButtonClick to update button text
       * Fifth Effect Custom: Calls updateAddToCartButtonText after quantity change
       */
      QtyBreakPrototype.handleButtonClick = function(event) {
        const selectedButton = event.currentTarget;
        const selectedQty = selectedButton.getAttribute('data-quantity');
        const inputField = this.querySelector('input[type="hidden"][name="quantity"]');
        inputField.value = selectedQty;

        this.buttons.forEach(button => {
          button.classList.remove('active');
        });
        selectedButton.classList.add('active');
        this.customParentElement.querySelector('form input[name="quantity"]').value = selectedButton.dataset.quantity;
        
        // Fifth Effect Custom: Update Add to Cart button with total price
        this.updateAddToCartButtonText(selectedButton);
      };

      // Store original updatePricing
      const originalUpdatePricing = QtyBreakPrototype.updatePricing;
      
      /**
       * Override updatePricing to update button text after pricing updates
       * Fifth Effect Custom: Updates button text after all pricing calculations
       */
      QtyBreakPrototype.updatePricing = function() {
        // Call original method
        if (originalUpdatePricing) {
          originalUpdatePricing.call(this);
        }
        
        // Fifth Effect Custom: Update Add to Cart button with active button's total price
        const activeButton = this.querySelector('.product-quantity-picker__pill-list button.active');
        if (activeButton) {
          this.updateAddToCartButtonText(activeButton);
        }
      };

      // Store original selectedQty
      const originalSelectedQty = QtyBreakPrototype.selectedQty;
      
      /**
       * Override selectedQty to update button text on initial selection
       * Fifth Effect Custom: Updates button text after initial quantity selection
       */
      QtyBreakPrototype.selectedQty = function() {
        const buttons = this.querySelectorAll('.product-quantity-picker__pill-list button');
        let activeButton = null;
        
        buttons.forEach(btn => {
          if (btn.dataset.mostPopular && !btn.getAttribute('disabled')) {
            buttons.forEach(button => {
              button.classList.remove('active');
            });
            btn.classList.add('active');
            activeButton = btn;
            if (this.customParentElement.querySelector('form input[name="quantity"]')) {
              this.customParentElement.querySelector('form input[name="quantity"]').value = btn.dataset.quantity;
            }
          } else if (!btn.dataset.mostPopular && btn.getAttribute('disabled')) {
            btn.classList.remove('active');
            buttons[0].classList.add('active');
            activeButton = buttons[0];
            if (this.customParentElement.querySelector('form input[name="quantity"]')) {
              this.customParentElement.querySelector('form input[name="quantity"]').value = buttons[0].dataset.quantity;
            }
          }
        });
        
        // Fifth Effect Custom: Update Add to Cart button with active button's total price
        if (activeButton) {
          this.updateAddToCartButtonText(activeButton);
        }
      };
      
      console.log('Fifth Effect: QtyBreak extended successfully');
    });
  }

  /**
   * Extends VariantPicker to show combined savings from compare_at_price in one-time mode.
   * Overrides updatePricing to recalculate savings labels after the original method runs.
   * Compare-at strike-through and per-unit prices remain unchanged (handled by core bundle).
   */
  function extendVariantPicker() {
    customElements.whenDefined('variant-picker').then(() => {
      const VariantPickerPrototype = customElements.get('variant-picker').prototype;

      const originalUpdatePricing = VariantPickerPrototype.updatePricing;

      VariantPickerPrototype.updatePricing = function() {
        if (originalUpdatePricing) {
          originalUpdatePricing.call(this);
        }

        // Only recalculate savings labels for one-time purchase mode
        if (this.classList.contains('subscription')) return;
        if (!this.variant) return;

        const savingsLabels = this.querySelectorAll(
          '.product-quantity-picker__pill-list button.savings-label .label'
        );

        if (!savingsLabels.length) return;

        let highestPrice;
        if (this.variant.compare_at_price > 0) {
          highestPrice = this.variant.compare_at_price;
        } else {
          highestPrice = this.variant.price;
        }

        savingsLabels.forEach((label) => {
          const isTestVersion = window.igData?.user?.getTestGroup(this.testGroupExperimentId)?.isControl === false;
          const savings = isTestVersion && label.dataset.testSavings
            ? parseFloat(label.dataset.testSavings) / 100
            : parseFloat(label.dataset.savings) / 100;

          const finalPrice = this.variant.price * (1 - savings);
          const totalDiscount = ((highestPrice - finalPrice) / highestPrice) * 100;
          label.innerText = `Save ${totalDiscount.toFixed(0)}%`;
        });
      };

      console.log('Fifth Effect: VariantPicker extended successfully');
    });
  }

  /**
   * Initialize button text with price after page load
   * Ensures all CTAs show price on initial page load
   */
  function initializeButtonPrices() {
    // Wait a bit for components to fully initialize and pricing to load
    setTimeout(() => {
      // Check for QtyBreak component
      const qtyBreak = document.querySelector('qty-break');
      if (qtyBreak) {
        const activeButton = qtyBreak.querySelector('.product-quantity-picker__pill-list button.active');
        if (activeButton && qtyBreak.updateAddToCartButtonText) {
          qtyBreak.updateAddToCartButtonText(activeButton);
        }
      }

      // Check for Predetermined Qty Gifts component
      const predetComponent = document.querySelector('predetermined-qty-gifts');
      if (predetComponent) {
        const activePill = predetComponent.querySelector('.predet-qty__pill.active');
        if (activePill && typeof predetComponent.updateAtcButtonPrice === 'function') {
          predetComponent.updateAtcButtonPrice(activePill);
        }
      }
    }, 500);
  }

  /**
   * Synchronizes Loop subscription widget state with variant-picker / qty-break pricing.
   * Uses a MutationObserver to detect when Loop renders its DOM (instead of fragile setTimeout).
   * Once detected, reads the initial purchase type and selling plan, sets the correct
   * class + data-selling-plan on the target element, and calls updatePricing().
   * Falls back after MAX_WAIT_MS with a console warning.
   */
  function syncLoopWidget() {
    const MAX_WAIT_MS = 10000;

    document.querySelectorAll('product-info').forEach(productInfo => {
      const loopWidget = productInfo.querySelector('.loop-widget-container');
      if (!loopWidget) return;

      const target = productInfo.querySelector('variant-picker') || productInfo.querySelector('qty-break');
      if (!target) return;

      /**
       * Reads Loop widget DOM and applies purchase type + selling plan to the target element.
       * @returns {boolean} true if Loop had fully rendered and sync succeeded
       */
      const applyLoopState = () => {
        const oneTime = loopWidget.querySelector('div[data-loop-widget-onetime-purchase-option]');
        const subscription = loopWidget.querySelector('div[data-loop-widget-selling-plan-group]');
        const loopSelect = loopWidget.querySelector('select.loop-widget-sp-selector[name="selling_plan"]');
        // Fallback: hidden input when Loop renders a single frequency (no <select>)
        const loopInput = !loopSelect
          ? loopWidget.querySelector('input[name="selling_plan"]')
          : null;

        // Loop hasn't rendered its purchase options yet
        if (!oneTime || !subscription) return false;

        const isOneTimeSelected = oneTime.classList.contains('loop-widget-purchase-option-selected');

        target.classList.toggle('one-time', isOneTimeSelected);
        target.classList.toggle('subscription', !isOneTimeSelected);

        if (!isOneTimeSelected) {
          const selectedOption = loopSelect?.querySelector('option[data-selected="true"]');
          const sellingPlanValue = selectedOption?.value || loopSelect?.value || loopInput?.value || '';
          if (sellingPlanValue) {
            target.dataset.sellingPlan = sellingPlanValue;
          }
        } else {
          delete target.dataset.sellingPlan;
        }

        // Explicit pricing update to guarantee correct initial render
        if (typeof target.updatePricing === 'function') {
          target.updatePricing();
        }

        // Re-append price to ATC button for predetermined-qty-gifts component
        const predetComponent = productInfo.querySelector('predetermined-qty-gifts');
        if (predetComponent) {
          const activePill = predetComponent.querySelector('.predet-qty__pill.active');
          if (activePill && typeof predetComponent.updateAtcButtonPrice === 'function') {
            requestAnimationFrame(() => predetComponent.updateAtcButtonPrice(activePill));
          }
        }

        console.log('Fifth Effect: Loop widget synced —', isOneTimeSelected ? 'one-time' : 'subscription');
        return true;
      };

      // If Loop already rendered (e.g. cached / fast network), sync immediately
      if (applyLoopState()) return;

      // Otherwise observe the Loop container until it renders
      let timeoutId = null;
      const initObserver = new MutationObserver(() => {
        if (applyLoopState()) {
          initObserver.disconnect();
          if (timeoutId) clearTimeout(timeoutId);
        }
      });

      initObserver.observe(loopWidget, { childList: true, subtree: true });

      // Safety timeout: stop waiting if Loop never renders
      timeoutId = setTimeout(() => {
        initObserver.disconnect();
        if (!applyLoopState()) {
          console.warn('Fifth Effect: Loop widget did not render within', MAX_WAIT_MS, 'ms — pricing may show one-time defaults.');
        }
      }, MAX_WAIT_MS);
    });
  }

  // ─────────────────────────────────────────────────────
  // URL Auto Add-to-Cart — Klaviyo / Email Marketing
  // Reads URL params (?add-to-cart=VARIANT_ID&qty=N&discount=CODE),
  // validates, adds to cart, applies discount, opens SmartCart,
  // and cleans the URL. Gated by theme setting.
  // ─────────────────────────────────────────────────────

  /**
   * Processes URL parameters to auto-add a product variant to cart.
   * Supports: ?add-to-cart=VARIANT_ID&qty=NUMBER&discount=CODE
   * Checks if variant is already in cart before adding.
   * Opens Rebuy SmartCart after processing.
   */
  async function handleUrlAutoAddToCart() {
    // Guard: Check theme setting
    const themeSettings = window.auroraTheme?.themeSettings;
    if (!themeSettings?.enable_url_auto_add_to_cart) return;

    // Guard: Check for add-to-cart param (exit immediately if absent — zero overhead)
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('add-to-cart');
    if (!variantParam) return;

    // Guard: Check allowed pages
    const allowedPages = (themeSettings.url_atc_allowed_pages || '').trim();
    if (allowedPages) {
      const patterns = allowedPages.split('\n').map(s => s.trim()).filter(Boolean);
      const currentPath = window.location.pathname;
      const isAllowed = patterns.some(pattern => wildcardToRegExp(pattern).test(currentPath));
      if (!isAllowed) return;
    }

    // Parse params
    const variantId = parseInt(variantParam, 10);
    if (!Number.isFinite(variantId) || variantId <= 0) {
      console.error('Fifth Effect: URL auto-add — invalid variant ID:', variantParam);
      return;
    }

    const qty = Math.max(1, parseInt(params.get('qty'), 10) || 1);
    const discountCode = (params.get('discount') || '').trim();

    // Clean URL immediately to prevent re-trigger on refresh
    const cleanParams = new URLSearchParams(params);
    cleanParams.delete('add-to-cart');
    cleanParams.delete('qty');
    cleanParams.delete('discount');
    const cleanSearch = cleanParams.toString();
    const cleanUrl = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
    history.replaceState(null, '', cleanUrl);

    try {
      // Fetch current cart
      const cartRoot = window.Shopify?.routes?.root || '/';
      const cartRes = await fetch(`${cartRoot}cart.js`);
      if (!cartRes.ok) throw new Error(`Cart fetch failed (${cartRes.status})`);
      const cart = await cartRes.json();

      // Check if variant is already in cart
      const alreadyInCart = cart.items?.some(item => Number(item.variant_id) === variantId);

      if (!alreadyInCart) {
        // Apply discount code first (sets session cookie)
        if (discountCode) {
          try {
            await fetch(`${cartRoot}discount/${encodeURIComponent(discountCode)}`, { method: 'GET' });
            console.log('Fifth Effect: URL auto-add — discount applied:', discountCode);
          } catch (err) {
            console.error('Fifth Effect: URL auto-add — discount apply failed:', err);
          }
        }

        // Add variant to cart
        const addRes = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        });

        if (!addRes.ok) {
          const errorData = await addRes.json().catch(() => null);
          trackSmartCartClarityEvent('cart_add_failed', {
            smartcart_source: 'url auto-add',
            smartcart_status: addRes.status,
            smartcart_variant_id: variantId,
            smartcart_quantity: qty,
            smartcart_error: errorData?.description || 'add failed'
          });
          const addError = new Error(errorData?.description || `Add to cart failed (${addRes.status})`);
          addError.status = addRes.status;
          addError.smartCartTelemetryRecorded = true;
          throw addError;
        }

        trackSmartCartClarityEvent('cart_add_success', {
          smartcart_source: 'url auto-add',
          smartcart_variant_id: variantId,
          smartcart_quantity: qty
        });

        // Sync cart count with theme
        const updatedCartRes = await fetch(`${cartRoot}cart.js`);
        if (updatedCartRes.ok) {
          const updatedCart = await updatedCartRes.json();
          syncUrlAtcCartCount(updatedCart);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        console.log('Fifth Effect: URL auto-add — variant', variantId, 'x' + qty, 'added to cart');

        // Open SmartCart after Rebuy has time to process the cart change
        openSmartCartWhenReady(1200);
      } else {
        console.log('Fifth Effect: URL auto-add — variant', variantId, 'already in cart, skipping add');

        // Still apply discount if provided
        if (discountCode) {
          try {
            await fetch(`${cartRoot}discount/${encodeURIComponent(discountCode)}`, { method: 'GET' });
            console.log('Fifth Effect: URL auto-add — discount applied:', discountCode);
          } catch (err) {
            console.error('Fifth Effect: URL auto-add — discount apply failed:', err);
          }
        }

        // Open SmartCart immediately — cart is already up to date
        openSmartCartWhenReady(300);
      }

    } catch (err) {
      if (!err?.smartCartTelemetryRecorded) {
        trackSmartCartClarityEvent('cart_add_failed', {
          smartcart_source: 'url auto-add',
          smartcart_status: err?.status || 'unknown',
          smartcart_variant_id: variantId,
          smartcart_quantity: qty,
          smartcart_error: err?.message || 'add failed'
        });
      }
      console.error('Fifth Effect: URL auto-add failed —', err);
    }
  }

  /**
   * Updates the theme's cart-count element after URL auto-add.
   * Mirrors the pattern from PopupConditionalPromo._syncCartCount.
   * @param {Object} cart - Cart JSON object
   */
  function syncUrlAtcCartCount(cart) {
    const cartCountElement = document.querySelector('cart-count');
    if (!cartCountElement) return;

    const itemCount = cart?.item_count || 0;
    const cartCountHTML = itemCount > 0
      ? `<div class='cart-count ${itemCount > 9 ? 'cart-count--ellipse' : ''}'><span aria-hidden='true'>${itemCount}</span></div>`
      : '';
    const mockNode = document.createElement('div');
    const newCartCountDiv = document.createElement('div');
    newCartCountDiv.id = 'NewCartCount';
    newCartCountDiv.innerHTML = cartCountHTML;
    mockNode.appendChild(newCartCountDiv);

    cartCountElement.dispatchEvent(new CustomEvent('update-nodes', {
      detail: { node: mockNode },
      bubbles: true
    }));
  }

  async function syncCartCountFromCartEndpoint(source) {
    try {
      const cartRoot = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${cartRoot}cart.js`, {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error(`Cart fetch failed with status ${cartResponse.status}`);
      }

      const cart = await cartResponse.json();
      syncUrlAtcCartCount(cart);
    } catch (error) {
      console.error('[Fifth Effect SmartCart] CART_COUNT_SYNC_FAILED - Could not sync native cart count before opening SmartCart.', {
        source,
        message: error?.message || String(error),
        userAgent: window.navigator?.userAgent || '',
        path: window.location?.pathname
      });
    }
  }

  let lastSmartCartOpenAt = 0;
  let lastNativeCartFallbackAt = 0;
  let nativeCartFallbackInProgress = false;
  let rebuyAvailabilityProbeStarted = false;
  let rebuyProbeCompleted = false;
  const NATIVE_CART_SESSION_KEY = 'FifthEffect-UseNativeCart';
  const REBUY_PROBE_DELAY_MS = 4500;
  const SESSION_NATIVE_DEBOUNCE_MS = 250;
  const SESSION_DRAWER_UPDATE_TIMEOUT_MS = 400;
  const REBUY_SESSION_CLEAR_EVENTS = ['rebuy.loaded', 'rebuy:smartcart.ready'];
  const SMART_CART_READY_EVENTS = [
    'rebuy.loaded',
    'rebuy:cart.ready',
    'rebuy:smartcart.ready',
    'rebuy:cart.add',
    'rebuy:cart.change'
  ];

  function isRebuySmartCartReady() {
    const smartCart = window.Rebuy?.SmartCart;
    const hasOpenMethod = typeof smartCart?.show === 'function' || typeof smartCart?.open === 'function';

    return Boolean(smartCart?.status === 'ready' && hasOpenMethod);
  }

  function getNativeCartSessionPreference() {
    try {
      const raw = sessionStorage.getItem(NATIVE_CART_SESSION_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.reason !== 'string') return null;

      return parsed;
    } catch {
      return null;
    }
  }

  function setNativeCartSessionPreference(reason) {
    try {
      sessionStorage.setItem(NATIVE_CART_SESSION_KEY, JSON.stringify({
        reason,
        setAt: new Date().toISOString()
      }));
    } catch {
      /* private mode / quota */
    }
  }

  function clearNativeCartSessionPreference() {
    try {
      sessionStorage.removeItem(NATIVE_CART_SESSION_KEY);
    } catch {
      /* noop */
    }
  }

  function shouldUseNativeCart() {
    if (isRebuySmartCartReady()) return false;
    if (getNativeCartSessionPreference()) return true;
    return rebuyProbeCompleted;
  }

  function trackRebuyCartUsed(source, details = {}) {
    trackSmartCartClarityEvent('rebuy_cart_used', {
      smartcart_source: source,
      smartcart_session_native_preferred: false,
      ...details
    });
  }

  function trackNativeCartUsed(source, details = {}) {
    trackSmartCartClarityEvent('native_cart_used', {
      smartcart_source: source,
      ...details
    });
  }

  function handleRebuyReadyForSession() {
    if (isRebuySmartCartReady()) {
      clearNativeCartSessionPreference();
    }
  }

  function startRebuyAvailabilityProbe() {
    if (rebuyAvailabilityProbeStarted) return;

    rebuyAvailabilityProbeStarted = true;

    REBUY_SESSION_CLEAR_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, handleRebuyReadyForSession);
    });

    const rebuyScript = document.querySelector('script[src*="rebuy.js"]');

    if (rebuyScript) {
      rebuyScript.addEventListener('error', () => {
        rebuyProbeCompleted = true;

        if (!isRebuySmartCartReady()) {
          setNativeCartSessionPreference('rebuy_script_error');
          trackSmartCartClarityEvent('smartcart_session_native_preferred', {
            smartcart_reason: 'rebuy_script_error'
          });
        }
      }, { once: true });
    }

    setTimeout(() => {
      rebuyProbeCompleted = true;

      if (isRebuySmartCartReady()) return;

      setNativeCartSessionPreference('rebuy_probe_timeout');
      trackSmartCartClarityEvent('smartcart_session_native_preferred', {
        smartcart_reason: 'rebuy_probe_timeout'
      });
    }, REBUY_PROBE_DELAY_MS);
  }

  function getSmartCartEnvironment() {
    const userAgent = window.navigator?.userAgent || '';
    const platform = window.navigator?.platform || '';
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && window.navigator?.maxTouchPoints > 1);
    const isFacebookInAppBrowser = /FBAN|FBAV|FBIOS|FB_IAB|FB_IABMV|Instagram/i.test(userAgent);

    return {
      userAgent,
      isIOS,
      isFacebookInAppBrowser,
      isMobileWebKit: isIOS || isFacebookInAppBrowser
    };
  }

  function trackSmartCartClarityEvent(eventName, details = {}) {
    if (typeof window.clarity !== 'function') return;

    try {
      window.clarity('event', eventName);

      Object.entries(details).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        window.clarity('set', `dn_${key}`, String(value).slice(0, 120));
      });
    } catch (error) {
      console.error('[Fifth Effect SmartCart] CLARITY_TELEMETRY_FAILED - Could not send SmartCart telemetry.', {
        eventName,
        message: error?.message || String(error)
      });
    }
  }

  function isSmartCartVisible() {
    if (window.Rebuy?.SmartCart?.visible === true) return true;

    const smartCartSelectors = [
      '#rebuy-cart.is-visible',
      '#rebuy-cart[aria-hidden="false"]',
      '.rebuy-cart.is-visible',
      '#rebuy-cart.rebuy-cart.is-visible'
    ];

    return smartCartSelectors.some((selector) => Boolean(document.querySelector(selector)));
  }

  function getSmartCartGraceOptions() {
    const environment = getSmartCartEnvironment();

    return {
      maxWait: environment.isMobileWebKit ? 3000 : 2500,
      interval: 125
    };
  }

  async function waitForSmartCartVisibility(options = {}) {
    const { maxWait, interval } = {
      ...getSmartCartGraceOptions(),
      ...options
    };
    const deadline = Date.now() + maxWait;

    while (Date.now() < deadline) {
      if (isSmartCartVisible()) {
        closeNativeCartDrawerIfOpen();
        return true;
      }

      await wait(interval);
    }

    if (isSmartCartVisible()) {
      closeNativeCartDrawerIfOpen();
      return true;
    }

    return false;
  }

  function closeNativeCartDrawerIfOpen() {
    const cartDrawer = document.querySelector('#CartDrawer');

    if (!cartDrawer?.isOpen) return;

    if (typeof cartDrawer.hide === 'function') {
      cartDrawer.hide(true);
    }
  }

  function shouldAbortNativeFallbackForHealthyRebuy() {
    if (isSmartCartVisible()) return true;

    const smartCart = window.Rebuy?.SmartCart;
    const recentlyOpenedSmartCart = Date.now() - lastSmartCartOpenAt < 5000;

    return Boolean(smartCart?.status === 'ready' && recentlyOpenedSmartCart);
  }

  function getSmartCartDiagnostics(source, attempts, lastError) {
    const rebuy = window.Rebuy;
    const smartCart = rebuy?.SmartCart;
    const smartCartRoot = document.querySelector('#rebuy-cart');
    let rebuyItemCount = null;

    try {
      rebuyItemCount = rebuy?.Cart && typeof rebuy.Cart.itemCount === 'function'
        ? rebuy.Cart.itemCount()
        : null;
    } catch (error) {
      rebuyItemCount = `unavailable: ${error?.message || error}`;
    }

    return {
      source,
      attempts,
      timestamp: new Date().toISOString(),
      path: window.location?.pathname,
      visibilityState: document.visibilityState,
      readyState: document.readyState,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      rebuyDefined: typeof rebuy !== 'undefined',
      smartCartDefined: Boolean(smartCart),
      smartCartStatus: smartCart?.status || null,
      smartCartHasShow: typeof smartCart?.show === 'function',
      smartCartHasOpen: typeof smartCart?.open === 'function',
      smartCartVisibleProperty: smartCart?.visible ?? null,
      smartCartRootFound: Boolean(smartCartRoot),
      smartCartRootClasses: smartCartRoot?.className || null,
      smartCartVisible: isSmartCartVisible(),
      rebuyCartDefined: Boolean(rebuy?.Cart),
      rebuyItemCount,
      lastError: lastError ? {
        name: lastError.name,
        message: lastError.message,
        stack: lastError.stack
      } : null,
      ...getSmartCartEnvironment()
    };
  }

  function logSmartCartError(code, message, source, attempts, lastError) {
    const diagnostics = getSmartCartDiagnostics(source, attempts, lastError);

    trackSmartCartClarityEvent(`smartcart_${code.toLowerCase()}`, {
      smartcart_source: source,
      smartcart_attempts: attempts,
      smartcart_status: diagnostics.smartCartStatus || 'unknown',
      smartcart_visible: diagnostics.smartCartVisible,
      smartcart_root_found: diagnostics.smartCartRootFound,
      smartcart_ios: diagnostics.isIOS,
      smartcart_facebook_in_app: diagnostics.isFacebookInAppBrowser,
      smartcart_mobile_webkit: diagnostics.isMobileWebKit,
      smartcart_error: lastError?.message || code
    });

    console.error(`[Fifth Effect SmartCart] ${code} - ${message}`, diagnostics);
  }

  function wait(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  function getCartFallbackUrl() {
    return window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
  }

  function isNativeCartDrawerVisible() {
    const cartDrawer = document.querySelector('#CartDrawer');

    return Boolean(
      cartDrawer &&
      (
        cartDrawer.isOpen === true ||
        cartDrawer.classList.contains('is-opened') ||
        cartDrawer.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function waitForNativeCartDrawerUpdate(cartDrawer, source, options = {}) {
    if (!cartDrawer || typeof cartDrawer.update !== 'function') {
      return Promise.resolve(false);
    }

    const timeoutMs = Number.isFinite(options.timeoutMs) ? options.timeoutMs : 1500;

    return new Promise((resolve) => {
      let settled = false;
      let timeoutId = null;

      const finish = (updated) => {
        if (settled) return;

        settled = true;
        if (timeoutId) clearTimeout(timeoutId);

        if (typeof cartDrawer.off === 'function') {
          cartDrawer.off('update-nodes', handleUpdate);
        }

        resolve(updated);
      };

      const handleUpdate = () => finish(true);

      if (typeof cartDrawer.on === 'function') {
        cartDrawer.on('update-nodes', handleUpdate);
      }

      try {
        const updateResult = cartDrawer.update();

        if (updateResult && typeof updateResult.then === 'function') {
          updateResult.then(() => finish(true)).catch((error) => {
            console.error('[Fifth Effect SmartCart] NATIVE_CART_UPDATE_FAILED - Native cart drawer update rejected.', {
              source,
              message: error?.message || String(error)
            });
            finish(false);
          });
        }
      } catch (error) {
        console.error('[Fifth Effect SmartCart] NATIVE_CART_UPDATE_FAILED - Could not refresh native cart drawer.', {
          source,
          message: error?.message || String(error)
        });
        finish(false);
        return;
      }

      timeoutId = setTimeout(() => finish(false), timeoutMs);
    });
  }

  function shouldAllowNativeCartFallbackAttempt(reason) {
    const now = Date.now();
    const debounceMs = reason === 'session_preferred' ? SESSION_NATIVE_DEBOUNCE_MS : 1000;

    if (isNativeCartDrawerVisible()) {
      return { allow: true, alreadyOpen: true, now };
    }

    if (nativeCartFallbackInProgress || now - lastNativeCartFallbackAt < debounceMs) {
      return { allow: false, alreadyOpen: false, now };
    }

    return { allow: true, alreadyOpen: false, now };
  }

  function refreshNativeCartInBackground(cartDrawer, source, skipDrawerPrefetch = false) {
    void syncCartCountFromCartEndpoint(source);

    if (skipDrawerPrefetch || !cartDrawer || typeof cartDrawer.update !== 'function') {
      return;
    }

    try {
      cartDrawer.update();
    } catch (error) {
      console.error('[Fifth Effect SmartCart] NATIVE_CART_BACKGROUND_UPDATE_FAILED - Could not refresh native cart drawer in background.', {
        source,
        message: error?.message || String(error)
      });
    }
  }

  function emitNativeCartDrawerUpdateNodes(cartDrawer) {
    if (!cartDrawer?.lastDrawerBody || typeof cartDrawer.emit !== 'function') {
      return;
    }

    cartDrawer.emit('update-nodes', { node: cartDrawer.lastDrawerBody });
  }

  async function openNativeCartFallbackFast(source, reason, options = {}) {
    const skipDrawerPrefetch = options.skipDrawerPrefetch === true;

    if (isSmartCartVisible() || shouldAbortNativeFallbackForHealthyRebuy()) {
      return true;
    }

    const attempt = shouldAllowNativeCartFallbackAttempt(reason);
    if (!attempt.allow) {
      return false;
    }

    if (attempt.alreadyOpen) {
      refreshNativeCartInBackground(document.querySelector('#CartDrawer'), source, skipDrawerPrefetch);
      return true;
    }

    nativeCartFallbackInProgress = true;
    lastNativeCartFallbackAt = attempt.now;

    trackSmartCartClarityEvent('smartcart_native_fallback_fast', {
      smartcart_source: source,
      smartcart_reason: reason,
      smartcart_skip_drawer_prefetch: skipDrawerPrefetch
    });

    try {
      const cartDrawer = document.querySelector('#CartDrawer');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        if (!skipDrawerPrefetch) {
          await waitForNativeCartDrawerUpdate(cartDrawer, source, {
            timeoutMs: reason === 'session_preferred' ? SESSION_DRAWER_UPDATE_TIMEOUT_MS : 1500
          });
        }

        if (!isNativeCartDrawerVisible()) {
          const openResult = cartDrawer.open();

          if (openResult && typeof openResult.then === 'function') {
            await Promise.race([openResult, wait(SESSION_DRAWER_UPDATE_TIMEOUT_MS)]);
          }
        } else if (!skipDrawerPrefetch) {
          refreshNativeCartInBackground(cartDrawer, source, false);
        }

        if (isNativeCartDrawerVisible()) {
          emitNativeCartDrawerUpdateNodes(cartDrawer);
          setNativeCartSessionPreference(reason);
          trackSmartCartClarityEvent('native_cart_drawer_opened', {
            smartcart_source: source,
            smartcart_reason: reason,
            smartcart_attempts: 0
          });
          trackNativeCartUsed(source, {
            native_cart_mode: 'drawer',
            native_cart_reason: reason,
            smartcart_attempts: 0,
            smartcart_session_native_preferred: true
          });
          return true;
        }
      }

      const cartUrl = getCartFallbackUrl();
      const targetUrl = new URL(cartUrl, window.location.origin);

      setNativeCartSessionPreference(reason);
      trackSmartCartClarityEvent('native_cart_page_redirect', {
        smartcart_source: source,
        smartcart_reason: reason,
        smartcart_attempts: 0
      });
      trackNativeCartUsed(source, {
        native_cart_mode: 'page',
        native_cart_reason: reason,
        smartcart_attempts: 0,
        smartcart_session_native_preferred: true
      });

      if (window.location.pathname !== targetUrl.pathname) {
        window.location.assign(cartUrl);
      }

      return true;
    } catch (error) {
      console.error('[Fifth Effect SmartCart] NATIVE_CART_FAST_FALLBACK_FAILED - Could not open native cart drawer quickly.', {
        source,
        reason,
        message: error?.message || String(error)
      });

      return openNativeCartFallback(source, reason, 0, error);
    } finally {
      nativeCartFallbackInProgress = false;
    }
  }

  async function openNativeCartFallback(source, reason, attempts, lastError) {
    const sessionPreference = getNativeCartSessionPreference();
    const graceOptions = sessionPreference
      ? { maxWait: 0, interval: 50 }
      : undefined;
    const smartCartVisibleAfterGrace = await waitForSmartCartVisibility(graceOptions);

    if (smartCartVisibleAfterGrace) {
      trackSmartCartClarityEvent('native_cart_fallback_aborted', {
        smartcart_source: source,
        smartcart_reason: reason,
        smartcart_abort_reason: 'smartcart_visible_after_grace'
      });
      return true;
    }

    if (shouldAbortNativeFallbackForHealthyRebuy()) {
      trackSmartCartClarityEvent('native_cart_fallback_aborted', {
        smartcart_source: source,
        smartcart_reason: reason,
        smartcart_abort_reason: 'rebuy_ready_recent_show'
      });
      return true;
    }

    const now = Date.now();
    const debounceMs = sessionPreference ? SESSION_NATIVE_DEBOUNCE_MS : 1000;

    if (nativeCartFallbackInProgress || now - lastNativeCartFallbackAt < debounceMs) {
      if (sessionPreference && isNativeCartDrawerVisible()) {
        return true;
      }

      return false;
    }

    nativeCartFallbackInProgress = true;
    lastNativeCartFallbackAt = now;

    const diagnostics = getSmartCartDiagnostics(source, attempts, lastError);

    trackSmartCartClarityEvent('smartcart_native_fallback', {
      smartcart_source: source,
      smartcart_reason: reason,
      smartcart_attempts: attempts,
      smartcart_status: diagnostics.smartCartStatus || 'unknown',
      smartcart_root_found: diagnostics.smartCartRootFound,
      smartcart_ios: diagnostics.isIOS,
      smartcart_facebook_in_app: diagnostics.isFacebookInAppBrowser,
      smartcart_mobile_webkit: diagnostics.isMobileWebKit,
      smartcart_error: lastError?.message || reason
    });

    console.warn('[Fifth Effect SmartCart] NATIVE_CART_FALLBACK - Opening native cart fallback.', {
      reason,
      ...diagnostics
    });

    try {
      await syncCartCountFromCartEndpoint(source);

      const cartDrawer = document.querySelector('#CartDrawer');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        if (shouldAbortNativeFallbackForHealthyRebuy()) {
          trackSmartCartClarityEvent('native_cart_fallback_aborted', {
            smartcart_source: source,
            smartcart_reason: reason,
            smartcart_abort_reason: 'rebuy_ready_before_native_open'
          });
          return true;
        }

        await waitForNativeCartDrawerUpdate(cartDrawer, source, {
          timeoutMs: sessionPreference ? SESSION_DRAWER_UPDATE_TIMEOUT_MS : 1500
        });

        if (shouldAbortNativeFallbackForHealthyRebuy()) {
          trackSmartCartClarityEvent('native_cart_fallback_aborted', {
            smartcart_source: source,
            smartcart_reason: reason,
            smartcart_abort_reason: 'rebuy_ready_after_native_update'
          });
          return true;
        }

        if (!isNativeCartDrawerVisible()) {
          const openResult = cartDrawer.open();

          if (openResult && typeof openResult.then === 'function') {
            await Promise.race([openResult, wait(1500)]);
          }
        }

        if (isNativeCartDrawerVisible()) {
          setNativeCartSessionPreference(reason);
          trackSmartCartClarityEvent('native_cart_drawer_opened', {
            smartcart_source: source,
            smartcart_reason: reason,
            smartcart_attempts: attempts
          });
          trackNativeCartUsed(source, {
            native_cart_mode: 'drawer',
            native_cart_reason: reason,
            smartcart_attempts: attempts,
            smartcart_session_native_preferred: Boolean(sessionPreference)
          });
          return true;
        }
      }

      const cartUrl = getCartFallbackUrl();
      const targetUrl = new URL(cartUrl, window.location.origin);

      setNativeCartSessionPreference(reason);
      trackSmartCartClarityEvent('native_cart_page_redirect', {
        smartcart_source: source,
        smartcart_reason: reason,
        smartcart_attempts: attempts
      });
      trackNativeCartUsed(source, {
        native_cart_mode: 'page',
        native_cart_reason: reason,
        smartcart_attempts: attempts,
        smartcart_session_native_preferred: Boolean(sessionPreference)
      });

      if (window.location.pathname !== targetUrl.pathname) {
        window.location.assign(cartUrl);
      }

      return true;
    } catch (error) {
      const cartUrl = getCartFallbackUrl();

      trackSmartCartClarityEvent('native_cart_fallback_failed', {
        smartcart_source: source,
        smartcart_reason: reason,
        smartcart_attempts: attempts,
        smartcart_error: error?.message || String(error)
      });

      console.error('[Fifth Effect SmartCart] NATIVE_CART_FALLBACK_FAILED - Could not open native cart drawer; redirecting to cart page.', {
        source,
        reason,
        message: error?.message || String(error)
      });

      setNativeCartSessionPreference(reason);
      trackNativeCartUsed(source, {
        native_cart_mode: 'page',
        native_cart_reason: reason,
        smartcart_attempts: attempts,
        smartcart_session_native_preferred: Boolean(sessionPreference),
        smartcart_error: error?.message || String(error)
      });

      window.location.assign(cartUrl);
      return false;
    } finally {
      nativeCartFallbackInProgress = false;
    }
  }

  function trackRebuyStatusSnapshot(source = 'unknown', trigger = 'click') {
    const diagnostics = getSmartCartDiagnostics(source, 0, null);

    trackSmartCartClarityEvent('rebuy_status_check', {
      smartcart_source: source,
      smartcart_trigger: trigger,
      rebuy_defined: diagnostics.rebuyDefined,
      rebuy_cart_defined: diagnostics.rebuyCartDefined,
      rebuy_item_count: diagnostics.rebuyItemCount,
      smartcart_defined: diagnostics.smartCartDefined,
      smartcart_status: diagnostics.smartCartStatus || 'unknown',
      smartcart_has_show: diagnostics.smartCartHasShow,
      smartcart_has_open: diagnostics.smartCartHasOpen,
      smartcart_visible: diagnostics.smartCartVisible,
      smartcart_root_found: diagnostics.smartCartRootFound,
      smartcart_mobile_webkit: diagnostics.isMobileWebKit,
      smartcart_facebook_in_app: diagnostics.isFacebookInAppBrowser,
      smartcart_ios: diagnostics.isIOS
    });
  }

  /**
   * Polls for Rebuy SmartCart readiness and opens it.
   * @param {number} initialDelay - ms to wait before first attempt (gives Rebuy time to sync cart state)
   * @param {Object} [options]
   * @param {string} [options.source] - Label used in warning logs
   * @param {number} [options.maxRetries]
   * @param {number} [options.retryInterval]
   */
  function openSmartCartWhenReady(initialDelay = 0, options = {}) {
    const environment = getSmartCartEnvironment();
    const source = options.source || 'SmartCart';
    const isCartOpenSource = /cart icon|cart link|header cart/i.test(source);
    const MAX_RETRIES = options.maxRetries || (
      isCartOpenSource
        ? (environment.isMobileWebKit ? 4 : 3)
        : (environment.isMobileWebKit ? 8 : 6)
    );
    const RETRY_INTERVAL = options.retryInterval || (environment.isMobileWebKit ? 750 : 500);
    const VERIFY_DELAY = options.verifyDelay || (environment.isMobileWebKit ? 900 : 400);
    const startTime = Date.now();
    const delay = Number.isFinite(initialDelay) ? Math.max(0, initialDelay) : 0;
    let attempts = 0;
    let timeoutId = null;
    let verifyTimeoutId = null;
    let isFinished = false;
    let lastError = null;

    trackSmartCartClarityEvent('smartcart_opener_called', {
      smartcart_source: source,
      smartcart_initial_delay: delay,
      smartcart_max_retries: MAX_RETRIES,
      smartcart_retry_interval: RETRY_INTERVAL,
      smartcart_ios: environment.isIOS,
      smartcart_facebook_in_app: environment.isFacebookInAppBrowser,
      smartcart_mobile_webkit: environment.isMobileWebKit
    });

    if (isCartOpenSource) {
      trackSmartCartClarityEvent('smartcart_click', {
        smartcart_source: source,
        smartcart_ios: environment.isIOS,
        smartcart_facebook_in_app: environment.isFacebookInAppBrowser,
        smartcart_mobile_webkit: environment.isMobileWebKit
      });
    }

    const sessionPreference = getNativeCartSessionPreference();

    if (sessionPreference) {
      if (isRebuySmartCartReady()) {
        clearNativeCartSessionPreference();
      } else {
        trackSmartCartClarityEvent('smartcart_session_native_preferred', {
          smartcart_source: source,
          smartcart_reason: sessionPreference.reason
        });
        openNativeCartFallbackFast(source, 'session_preferred');
        return;
      }
    }

    const cleanup = () => {
      SMART_CART_READY_EVENTS.forEach((eventName) => {
        document.removeEventListener(eventName, handleReadyEvent);
      });
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      if (verifyTimeoutId) {
        clearTimeout(verifyTimeoutId);
        verifyTimeoutId = null;
      }
    };

    const showSmartCart = () => {
      const smartCart = window.Rebuy?.SmartCart;
      const hasOpenMethod = typeof smartCart?.show === 'function' || typeof smartCart?.open === 'function';
      const hasBlockingStatus = smartCart?.status && smartCart.status !== 'ready';
      const canOpen = hasOpenMethod && !hasBlockingStatus;

      if (!canOpen) return false;

      const now = Date.now();
      if (now - lastSmartCartOpenAt < 1000 && isSmartCartVisible()) {
        return true;
      }

      try {
        trackSmartCartClarityEvent('smartcart_show_called', {
          smartcart_source: source,
          smartcart_attempts: attempts,
          smartcart_status: smartCart?.status || 'unknown',
          smartcart_method: typeof smartCart.show === 'function' ? 'show' : 'open'
        });

        if (typeof smartCart.show === 'function') {
          smartCart.show();
        } else {
          smartCart.open();
        }
      } catch (error) {
        lastError = error;
        logSmartCartError('OPEN_EXCEPTION', 'Rebuy SmartCart threw while trying to open.', source, attempts, lastError);
        return false;
      }

      lastSmartCartOpenAt = now;
      return 'verify';
    };

    const scheduleTryOpen = (wait) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(tryOpen, Math.max(0, wait));
    };

    function handleReadyEvent() {
      if (isFinished || verifyTimeoutId) return;

      const elapsed = Date.now() - startTime;
      scheduleTryOpen(delay - elapsed);
    }

    const finishWithVisibleSmartCart = () => {
      closeNativeCartDrawerIfOpen();
      clearNativeCartSessionPreference();
      isFinished = true;
      cleanup();
      trackSmartCartClarityEvent('smartcart_visible', {
        smartcart_source: source,
        smartcart_attempts: attempts
      });
      trackRebuyCartUsed(source, {
        smartcart_attempts: attempts
      });
    };

    function tryOpen() {
      timeoutId = null;

      if (isFinished) return;

      if (isSmartCartVisible()) {
        finishWithVisibleSmartCart();
        return;
      }

      attempts++;
      const openResult = showSmartCart();

      if (openResult === true) {
        finishWithVisibleSmartCart();
        return;
      }

      if (openResult === 'verify') {
        verifyTimeoutId = setTimeout(() => {
          verifyTimeoutId = null;

          if (isSmartCartVisible()) {
            finishWithVisibleSmartCart();
            return;
          }

          if (attempts < MAX_RETRIES) {
            scheduleTryOpen(RETRY_INTERVAL);
            return;
          }

          isFinished = true;
          cleanup();
          logSmartCartError('OPEN_NOT_VISIBLE', 'Rebuy SmartCart API was called, but the drawer did not become visible.', source, attempts, lastError);
          openNativeCartFallback(source, 'open_not_visible', attempts, lastError);
        }, VERIFY_DELAY);
        return;
      }

      if (attempts < MAX_RETRIES) {
        scheduleTryOpen(RETRY_INTERVAL);
        return;
      }

      isFinished = true;
      cleanup();
      logSmartCartError('NOT_READY_TIMEOUT', `Rebuy SmartCart was not ready after ${delay + MAX_RETRIES * RETRY_INTERVAL}ms.`, source, attempts, lastError);
      openNativeCartFallback(source, 'not_ready_timeout', attempts, lastError);
    }

    SMART_CART_READY_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, handleReadyEvent);
    });
    scheduleTryOpen(delay);
  }

  window.fifthFxOpenSmartCartWhenReady = openSmartCartWhenReady;
  window.fifthFxShouldUseNativeCart = shouldUseNativeCart;
  window.fifthFxTrackSmartCartEvent = trackSmartCartClarityEvent;
  window.fifthFxTrackRebuyStatus = trackRebuyStatusSnapshot;

  document.addEventListener('cart:refresh', async (event) => {
    const source = event?.detail?.source || 'cart:refresh';

    trackSmartCartClarityEvent('cart_refresh_received', {
      smartcart_source: source
    });

    const sessionPreference = getNativeCartSessionPreference();

    if (sessionPreference && !isRebuySmartCartReady()) {
      const cartDrawer = document.querySelector('#CartDrawer');

      if (cartDrawer && typeof cartDrawer.update === 'function') {
        await waitForNativeCartDrawerUpdate(cartDrawer, source, {
          timeoutMs: SESSION_DRAWER_UPDATE_TIMEOUT_MS
        });
      }

      await openNativeCartFallbackFast(source, 'session_preferred');
      return;
    }

    await syncCartCountFromCartEndpoint(source);
    openSmartCartWhenReady(1200, { source });
  });

  // ─────────────────────────────────────────────────────
  // Search sidebar — dynamic Search & Discovery suggestions
  // ─────────────────────────────────────────────────────

  function escapeSearchSuggestionText(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function initSearchSidebarPredictiveFetch() {
    const predictiveUrl = window.routes?.predictive_search_url;
    if (!predictiveUrl || window.__fifthFxPredictiveFetchPatched) {
      return;
    }

    window.__fifthFxPredictiveFetchPatched = true;
    const nativeFetch = window.fetch.bind(window);

    window.fetch = function patchedPredictiveFetch(input, init) {
      const requestUrl = typeof input === 'string' ? input : input?.url;

      if (!requestUrl || !requestUrl.includes(predictiveUrl) || !requestUrl.includes('section_id=')) {
        return nativeFetch(input, init);
      }

      const sidebar = document.getElementById('SearchSidebar');
      if (!sidebar) {
        return nativeFetch(input, init);
      }

      let searchQuery = '';

      try {
        const parsed = new URL(requestUrl, window.location.origin);
        searchQuery = parsed.searchParams.get('q') || '';
        parsed.searchParams.delete('resources[limit]');
        parsed.searchParams.delete('resources[limit_scope]');
        parsed.searchParams.set('resources[limit]', '10');
        parsed.searchParams.set('resources[limit_scope]', 'each');

        return nativeFetch(parsed.toString(), init).then((response) => {
          if (response.ok && sidebar.dataset.viewAllShowCount && searchQuery.trim()) {
            fetchSearchProductCount(searchQuery);
          }

          return response;
        });
      } catch (error) {
        console.error('Fifth Effect: Failed to patch predictive search URL.', error);
        return nativeFetch(input, init);
      }
    };
  }

  let searchProductCountAbortController = null;
  let searchProductCountActiveQuery = '';
  let searchProductCountRequestToken = 0;
  const SEARCH_VIEW_ALL_MIN_QUERY_LENGTH = 2;

  function hideSearchViewAllCount(sidebar) {
    sidebar.querySelectorAll('[data-search-view-all-count-wrap]').forEach((wrap) => {
      wrap.hidden = true;
      const countElement = wrap.querySelector('[data-search-view-all-count]');

      if (countElement) {
        countElement.textContent = '';
      }
    });
  }

  function showSearchViewAllCount(sidebar, count) {
    if (!count || count <= 0) {
      hideSearchViewAllCount(sidebar);
      return;
    }

    sidebar.querySelectorAll('[data-search-view-all-count-wrap]').forEach((wrap) => {
      const countElement = wrap.querySelector('[data-search-view-all-count]');

      if (countElement) {
        countElement.textContent = String(count);
        wrap.hidden = false;
      }
    });
  }

  function parseSearchProductCountFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const countElement =
      doc.querySelector('#shopify-section-search-product-count [data-search-product-count]') ||
      doc.querySelector('[data-search-product-count]');

    if (!countElement) {
      return null;
    }

    const count = parseInt(countElement.getAttribute('data-search-product-count'), 10);
    return Number.isNaN(count) ? null : count;
  }

  async function fetchSearchProductCount(query) {
    const sidebar = document.getElementById('SearchSidebar');

    if (!sidebar?.dataset.viewAllShowCount) {
      return;
    }

    const trimmed = query.trim();

    hideSearchViewAllCount(sidebar);

    if (!trimmed) {
      return;
    }

    if (trimmed.length < SEARCH_VIEW_ALL_MIN_QUERY_LENGTH) {
      return;
    }

    if (trimmed !== searchProductCountActiveQuery) {
      if (searchProductCountAbortController) {
        searchProductCountAbortController.abort();
      }

      searchProductCountActiveQuery = trimmed;
      searchProductCountAbortController = new AbortController();
    } else if (!searchProductCountAbortController) {
      searchProductCountAbortController = new AbortController();
    }

    const token = ++searchProductCountRequestToken;
    const signal = searchProductCountAbortController.signal;
    const root = window.Shopify?.routes?.root || window.routes?.root || '/';
    const url = `${root}search?q=${encodeURIComponent(trimmed)}&type=product&section_id=search-product-count`;

    try {
      const response = await fetch(url, { signal });

      if (!response.ok || token !== searchProductCountRequestToken) {
        hideSearchViewAllCount(sidebar);
        return;
      }

      const html = await response.text();
      const count = parseSearchProductCountFromHtml(html);

      if (count === null || token !== searchProductCountRequestToken) {
        hideSearchViewAllCount(sidebar);
        return;
      }

      showSearchViewAllCount(sidebar, count);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Fifth Effect: Failed to fetch search product count.', error);
        hideSearchViewAllCount(sidebar);
      }
    }
  }

  initSearchSidebarPredictiveFetch();

  function initSearchSidebarViewAllCount() {
    const sidebar = document.getElementById('SearchSidebar');

    if (!sidebar?.dataset.viewAllShowCount) {
      return;
    }

    let mutationDebounceTimer = null;
    const results = sidebar.querySelector('[data-sidebar-search-content-results]');

    if (!results) {
      return;
    }

    const observer = new MutationObserver(() => {
      const input = sidebar.querySelector('[data-sidebar-search-input]');
      const countWrap = sidebar.querySelector('[data-search-view-all-count-wrap]');

      if (!input?.value.trim() || !countWrap) {
        return;
      }

      clearTimeout(mutationDebounceTimer);
      mutationDebounceTimer = setTimeout(() => {
        fetchSearchProductCount(input.value);
      }, 150);
    });

    observer.observe(results, { childList: true, subtree: true });
  }

  function parseFallbackQueries(sidebar) {
    try {
      const parsed = JSON.parse(sidebar.dataset.fallbackQueries || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      console.error('Fifth Effect: Failed to parse search fallback queries.', error);
      return [];
    }
  }

  function renderSearchSuggestionButtons(list, queries) {
    if (!list) {
      return;
    }

    if (!queries.length) {
      list.innerHTML = '';
      return;
    }

    list.innerHTML = queries
      .map((query) => {
        const safeQuery = escapeSearchSuggestionText(query);
        return `<button class="unstyled-button search-sidebar-section__query link-parent-for-hover" data-sidebar-search-query="${safeQuery}"><span class="underline-animation">${safeQuery}</span></button>`;
      })
      .join('');
  }

  function showSearchSuggestionsLoading(sidebar) {
    sidebar.querySelectorAll('[data-sidebar-search-suggestions-list]').forEach((list) => {
      list.innerHTML =
        '<span class="search-sidebar__suggestions-loading" data-sidebar-search-suggestions-loading aria-live="polite">Loading suggestions…</span>';
    });
  }

  async function fetchSearchDiscoverySuggestions(sidebar) {
    const input = sidebar.querySelector('[data-sidebar-search-input]');
    if (input && input.value.trim()) {
      return;
    }

    const lists = sidebar.querySelectorAll('[data-sidebar-search-suggestions-list]');
    if (!lists.length) {
      return;
    }

    const fallbackQueries = parseFallbackQueries(sidebar);
    const bootstrap = sidebar.dataset.suggestionsBootstrap || 'a';
    const limit = sidebar.dataset.suggestionsLimit || '10';
    const predictiveUrl = window.routes?.predictive_search_url;

    if (!predictiveUrl) {
      lists.forEach((list) => renderSearchSuggestionButtons(list, fallbackQueries));
      return;
    }

    showSearchSuggestionsLoading(sidebar);

    try {
      const requestUrl = `${predictiveUrl}.json?q=${encodeURIComponent(bootstrap)}&resources[type]=query&resources[limit]=${encodeURIComponent(limit)}`;
      const response = await fetch(requestUrl);

      if (!response.ok) {
        throw new Error(`Predictive search request failed (${response.status})`);
      }

      const data = await response.json();
      const queryResults =
        data?.resources?.results?.queries || data?.resources?.queries || [];
      const queries = queryResults
        .map((item) => item?.text)
        .filter(Boolean)
        .slice(0, Number(limit) || 10);

      const resolvedQueries = queries.length ? queries : fallbackQueries;
      lists.forEach((list) => renderSearchSuggestionButtons(list, resolvedQueries));
    } catch (error) {
      console.error('Fifth Effect: Failed to load search suggestions.', error);
      lists.forEach((list) => renderSearchSuggestionButtons(list, fallbackQueries));
    }
  }

  function initSearchSidebarSuggestions() {
    const sidebar = document.getElementById('SearchSidebar');
    if (!sidebar || sidebar.dataset.suggestionsSource !== 'search_discovery') {
      return;
    }

    let inputClearTimer;

    const handleSidebarOpen = () => {
      if (sidebar.classList.contains('is-opened')) {
        fetchSearchDiscoverySuggestions(sidebar);
      }
    };

    const observer = new MutationObserver(handleSidebarOpen);
    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });

    sidebar.addEventListener('input', (event) => {
      const target = event.target;
      if (!target.matches('[data-sidebar-search-input]')) {
        return;
      }

      clearTimeout(inputClearTimer);

      if (!target.value.trim()) {
        inputClearTimer = setTimeout(() => {
          fetchSearchDiscoverySuggestions(sidebar);
        }, 550);
      }
    });

    if (sidebar.classList.contains('is-opened')) {
      fetchSearchDiscoverySuggestions(sidebar);
    }
  }

  // Initialize extensions when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      extendQtyBreak();
      extendVariantPicker();
      initializeButtonPrices();
      syncLoopWidget();
      handleUrlAutoAddToCart();
      startRebuyAvailabilityProbe();
      initSearchSidebarSuggestions();
      initSearchSidebarViewAllCount();
    });
  } else {
    extendQtyBreak();
    extendVariantPicker();
    initializeButtonPrices();
    syncLoopWidget();
    handleUrlAutoAddToCart();
    startRebuyAvailabilityProbe();
    initSearchSidebarSuggestions();
    initSearchSidebarViewAllCount();
  }

  // ─────────────────────────────────────────────────────
  // Conditional Promo Popup — Custom Element
  // Handles customer/cart-based popup display with dynamic
  // threshold messaging. Replicates ConditionRuntime logic
  // from the theme core since we can't import from the
  // webpack bundle.
  // ─────────────────────────────────────────────────────

  const POPUP_STORAGE_KEY = 'AuroraTheme-Popup';
  const POPUP_ANIMATION_DELAY = 400;

  const TIME_DELAY_MAP = {
    'none': 0, '3sec': 3000, '5sec': 5000, '15sec': 15000,
    '30sec': 30000, '1min': 60000, '2min': 120000
  };

  const FREQUENCY_MAP = {
    '1h': 3600000, '12h': 43200000, '1d': 86400000,
    '3d': 259200000, '1w': 604800000, '2w': 1209600000
  };

  const SCROLL_THRESHOLD = { '25': 20, '50': 40, '75': 55, '100': 99 };

  /**
   * Converts a wildcard pattern to a RegExp.
   * @param {string} pattern - Wildcard URL pattern (e.g., "/collections/*")
   * @returns {RegExp}
   */
  function wildcardToRegExp(pattern) {
    return new RegExp('^' + pattern.replace(/[.+^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$');
  }

  /**
   * Formats a cent amount using the shop's Shopify money_format string.
   * Supports {{ amount }}, {{ amount_no_decimals }}, {{ amount_with_comma_separator }},
   * {{ amount_no_decimals_with_comma_separator }}, {{ amount_with_apostrophe_separator }}.
   * @param {number} cents - Amount in cents
   * @param {string} format - Shopify money_format string
   * @returns {string}
   */
  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    const parts = amount.split('.');

    const amountWithComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    const amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const amountWithApostrophe = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1];

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amountWithApostrophe)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  class PopupConditionalPromo extends HTMLElement {
    constructor() {
      super();
      this._isVisible = false;
      this._overlayEl = null;
      this._contentEl = null;
      this._timerRef = null;
      this._startDate = null;
      this._cartObserver = null;
      this._isUpdatingCartMessages = false;
      this._promoButtonRequestInFlight = false;
    }

    connectedCallback() {
      // In theme editor, handle block select/deselect
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.blockId === this.dataset.blockId) this._show();
        });
        document.addEventListener('shopify:block:deselect', (e) => {
          if (e.detail.blockId === this.dataset.blockId) this._hide();
        });
        return;
      }

      // URL bypass gate: if bypass is enabled but condition not met and URL param absent, skip
      if (this.dataset.enableUrlBypass === 'true' && this.dataset.customerConditionMet === 'false') {
        const params = new URLSearchParams(window.location.search);
        const bypassParam = params.get('bypass-condition');
        const bypassKey = (this.dataset.urlBypassKey || '').trim();

        // If block has a key, param must match it exactly; otherwise accept 'true'
        const isMatch = bypassKey
          ? bypassParam === bypassKey
          : bypassParam === 'true';

        if (!isMatch) {
          this.remove();
          return;
        }
      }

      this._initConditions();
    }

    disconnectedCallback() {
      this._cleanup();
      this._cartObserver?.disconnect();
      if (this._boundSmartCartHandler) {
        document.removeEventListener('rebuy:smartcart.show', this._boundSmartCartHandler);
      }
      clearTimeout(this._smartcartDelayTimer);
    }

    // ── Condition Runtime (replicates theme's ConditionRuntime) ──

    _initConditions() {
      const d = this.dataset;
      this._pageCondition = d.pageCondition || 'all';
      this._whenShow = d.whenShow || 'immediately';
      this._pages = d.pages || '';
      this._timeDelay = d.timeDelay === 'none' ? null : d.timeDelay;
      this._pageScroll = d.pageScroll === 'none' ? null : d.pageScroll;
      this._exitIntent = d.exitIntent === 'true';
      this._frequency = d.frequency || 'unlimited';
      this._productTags = (d.productTags || '').split(',').map(t => t.trim().toLowerCase()).filter(Boolean);

      // Check frequency from storage
      const storageData = this._loadStorage();
      this._lastShowDate = storageData?.lastShow ? new Date(storageData.lastShow) : null;

      if (!this._shouldShowOnThisPage()) return;

      // Exclusive Rebuy SmartCart trigger — ignores frequency and all other triggers
      if (d.enableAfterRebuyOpen === 'true') {
        this._smartcartDelay = parseInt(d.smartcartDelay, 10) || 0;
        this._boundSmartCartHandler = () => this._handleSmartCartOpen();
        document.addEventListener('rebuy:smartcart.show', this._boundSmartCartHandler);
        return;
      }

      // SmartCart trigger — independent of frequency, once per page session
      this._enableSmartcartTrigger = d.enableSmartcartTrigger === 'true';
      this._smartcartDelay = parseInt(d.smartcartDelay, 10) || 0;
      if (this._enableSmartcartTrigger) {
        this._boundSmartCartHandler = () => this._handleSmartCartOpen();
        document.addEventListener('rebuy:smartcart.show', this._boundSmartCartHandler);
      }

      // Frequency-based triggers (time, scroll, exit intent) — respect frequency gate
      if (this._frequency === 'once' && this._lastShowDate) return;
      if (this._frequency !== 'unlimited' && this._lastShowDate) {
        const freqMs = FREQUENCY_MAP[this._frequency] || 0;
        if (freqMs > 0 && Date.now() - freqMs < this._lastShowDate.getTime()) return;
      }

      this._startDate = new Date();
      this._timerRef = window.setInterval(() => this._tick(), 1000);
      this._tick();

      if (this._exitIntent && !this._isMobile()) {
        this._handleMouseLeave = this._handleMouseLeave.bind(this);
        document.addEventListener('mouseout', this._handleMouseLeave);
      }

      if (this._pageScroll) {
        this._handleWindowScroll = this._handleWindowScroll.bind(this);
        window.addEventListener('scroll', this._handleWindowScroll);
        this._handleWindowScroll();
      }
    }

    _shouldShowOnThisPage() {
      if (this._pageCondition === 'target') {
        const urls = this._pages.split('\n').map(s => {
          try { return new URL(s.trim()).pathname; } catch { return null; }
        }).filter(Boolean);
        for (const pattern of urls) {
          if (wildcardToRegExp(pattern).test(window.location.pathname)) return true;
        }
        return false;
      }
      if (this._pageCondition === 'tags') {
        const currentTags = window.auroraProductTags;
        if (!currentTags || !Array.isArray(currentTags) || currentTags.length === 0) return false;
        return currentTags.map(t => t.toLowerCase().replace(/\s+/g, '')).some(t => this._productTags.includes(t));
      }
      return true;
    }

    _tick() {
      if (this._whenShow === 'immediately') { this._triggerShow(); return; }
      if (this._timeDelay) {
        const delayMs = TIME_DELAY_MAP[this._timeDelay] || 0;
        if (Date.now() - delayMs >= this._startDate.getTime()) this._triggerShow();
      }
    }

    _handleWindowScroll() {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = docHeight === winHeight ? 1 : scrollTop / (docHeight - winHeight);
      const scrollRounded = Math.round(scrollPercent * 100);
      if (scrollRounded >= (SCROLL_THRESHOLD[this._pageScroll] || 0)) this._triggerShow();
    }

    _handleMouseLeave(e) {
      if (!e.toElement && !e.relatedTarget) this._triggerShow();
    }

    _isMobile() {
      return window.innerWidth < 768;
    }

    _triggerShow() {
      this._cleanup();
      this._show();
    }

    _cleanup() {
      clearInterval(this._timerRef);
      clearTimeout(this._smartcartDelayTimer);
      if (this._pageScroll) window.removeEventListener('scroll', this._handleWindowScroll);
      if (this._exitIntent && !this._isMobile()) document.removeEventListener('mouseout', this._handleMouseLeave);
    }

    _handleSmartCartOpen() {
      if (this._isVisible) return;

      // One-time per session — remove listener after first trigger
      if (this._boundSmartCartHandler) {
        document.removeEventListener('rebuy:smartcart.show', this._boundSmartCartHandler);
        this._boundSmartCartHandler = null;
      }

      // skipStorage: true — SmartCart trigger does NOT write to frequency storage
      this._smartcartDelayTimer = setTimeout(() => {
        this._cleanup();
        this._show({ skipStorage: true });
      }, this._smartcartDelay);
    }

    // ── Storage (mirrors theme's PopupStorage) ──

    _loadStorage() {
      try {
        const raw = localStorage.getItem(POPUP_STORAGE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        return data[this.dataset.blockId] || null;
      } catch { return null; }
    }

    _saveStorage() {
      try {
        const raw = localStorage.getItem(POPUP_STORAGE_KEY);
        const data = raw ? JSON.parse(raw) : {};
        data[this.dataset.blockId] = {
          type: 'conditional_promo',
          lastShow: new Date().toISOString()
        };
        localStorage.setItem(POPUP_STORAGE_KEY, JSON.stringify(data));
      } catch { /* storage full or blocked */ }
    }

    // ── Show / Hide ──

    async _show(options = {}) {
      if (this._isVisible) return;

      // Clone template and hydrate cart messaging before the popup becomes visible.
      const template = this.querySelector('template[data-modal-template]');
      if (!template) return;

      const clone = template.content.cloneNode(true);
      this._contentEl = clone.firstElementChild || clone.children[0];

      const shouldSyncCartState = this.dataset.enableCartCondition === 'true' || this._shouldUseGiftAddToCart();
      if (shouldSyncCartState) {
        await this._syncPopupCartState(this._contentEl);
      }

      this.appendChild(clone);

      // Bind close buttons
      this._contentEl.querySelectorAll('[data-close-small-btn], [data-close-btn]').forEach(btn => {
        btn.addEventListener('click', () => this._hide());
      });
      this._bindPromoButton(this._contentEl);

      const variant = this.dataset.variant;

      if (variant === 'lightbox') {
        // Create overlay
        this._overlayEl = document.createElement('div');
        this._overlayEl.style.cssText = `
          position: fixed; inset: 0; z-index: 2147483646;
          transition: opacity ${POPUP_ANIMATION_DELAY}ms ease;
          opacity: 0;
        `;

        const withGradient = !!this.dataset.overlayGradient;
        if (withGradient) {
          this._overlayEl.style.background = this.dataset.overlayGradient;
          this._overlayEl.style.opacity = this.dataset.overlayOpacity;
        } else {
          const opacity = Number(this.dataset.overlayOpacity) * 100;
          this._overlayEl.style.background = `color-mix(in srgb, ${this.dataset.overlaySolid} ${opacity}%, transparent)`;
        }

        const blur = this.dataset.overlayBlur;
        if (blur && parseFloat(blur) > 0) {
          this._overlayEl.style.backdropFilter = `blur(${blur}px)`;
          this._overlayEl.style.webkitBackdropFilter = `blur(${blur}px)`;
        }

        this._overlayEl.addEventListener('click', () => this._hide());
        document.body.appendChild(this._overlayEl);

        // Animate in
        requestAnimationFrame(() => {
          this._overlayEl.style.opacity = '1';
          this.classList.add('popup--active');
        });

        // Lock body scroll
        document.body.style.overflow = 'hidden';
      } else {
        // Flyout
        requestAnimationFrame(() => {
          this.classList.add('popup--active', 'is-opened');
        });
      }

      // Show image after animation
      const hasImage = this.dataset.hasImage === 'true';
      const hideImgMobile = this.dataset.hideImgMobile === 'true';
      if (hasImage && !(hideImgMobile && this._isMobile())) {
        setTimeout(() => this.classList.add('popup--show-image'), POPUP_ANIMATION_DELAY);
      }

      this._isVisible = true;
      if (!options.skipStorage) this._saveStorage();

      if (shouldSyncCartState) {
        this._observeCartChanges();
      }

      // Trap focus
      this.focus();

      // Escape key handler
      this._escHandler = (e) => { if (e.key === 'Escape') this._hide(); };
      document.addEventListener('keydown', this._escHandler);
    }

    _hide() {
      if (!this._isVisible) return;

      this.classList.add('popup--closing');
      this.classList.remove('popup--active', 'popup--show-image', 'is-opened');

      if (this._overlayEl) {
        this._overlayEl.style.opacity = '0';
      }

      setTimeout(() => {
        this.classList.remove('popup--closing');

        // Remove cloned content
        const body = this.querySelector('.popup__body');
        if (body) body.remove();

        // Remove overlay
        if (this._overlayEl) {
          this._overlayEl.remove();
          this._overlayEl = null;
          document.body.style.overflow = '';
        }

        this._isVisible = false;
        this._promoButtonRequestInFlight = false;
      }, POPUP_ANIMATION_DELAY);

      document.removeEventListener('keydown', this._escHandler);
      this._cartObserver?.disconnect();
    }

    // ── Cart-based dynamic messaging ──

    _shouldUseGiftAddToCart() {
      return this.dataset.enableGiftAddToCartCta === 'true'
        && this._getGiftVariantId() !== null
        && this.dataset.giftVariantAvailable === 'true';
    }

    _getGiftVariantId() {
      const variantId = parseInt(this.dataset.giftVariantId, 10);
      return Number.isFinite(variantId) && variantId > 0 ? variantId : null;
    }

    _getPromoButton(root = this) {
      return root.querySelector('[data-promo-btn]');
    }

    _getPromoButtonLabelTarget(button) {
      return button?.querySelector('[data-promo-btn-label]') || button || null;
    }

    _setPromoButtonLabel(button, label) {
      const labelTarget = this._getPromoButtonLabelTarget(button);
      if (!button || !labelTarget) return;

      labelTarget.textContent = label;
      button.setAttribute('aria-label', label);
    }

    _setPromoButtonBusy(button, isBusy) {
      if (!button) return;

      button.classList.toggle('loading', isBusy);
      button.setAttribute('aria-disabled', isBusy ? 'true' : 'false');
      button.style.pointerEvents = isBusy ? 'none' : '';
    }

    _showPromoFeedback(message) {
      const feedbackEl = this._contentEl?.querySelector('[data-promo-feedback]');
      if (!feedbackEl) return;

      feedbackEl.textContent = message;
      feedbackEl.classList.remove('hidden');
    }

    _renderPromoButtonState(cart, root = this) {
      const button = this._getPromoButton(root);
      if (!button) return;

      const defaultLabel = this.dataset.promoBtnLabel || '';
      const addToCartLabel = this.dataset.addToCartLabel || 'Add To Cart';

      if (!this._shouldUseGiftAddToCart()) {
        this._setPromoButtonLabel(button, defaultLabel);
        button.dataset.promoAction = 'navigate';
        button.dataset.giftInCart = 'false';
        return;
      }

      const giftInCart = this._isGiftInCart(cart);
      this._setPromoButtonLabel(button, giftInCart ? defaultLabel : addToCartLabel);
      button.dataset.promoAction = giftInCart ? 'navigate' : 'add-to-cart';
      button.dataset.giftInCart = giftInCart ? 'true' : 'false';
    }

    _isGiftInCart(cart) {
      const variantId = this._getGiftVariantId();
      if (!variantId || !cart?.items) return false;

      return cart.items.some(item => Number(item.variant_id) === variantId);
    }

    _getAdjustedCartTotal(cart) {
      const total = cart?.total_price || 0;
      const giftVariantId = this._getGiftVariantId();
      if (!giftVariantId || !cart?.items) return total;

      const giftLine = cart.items.find(item => Number(item.variant_id) === giftVariantId);
      return giftLine ? total - (giftLine.final_line_price || 0) : total;
    }

    _bindPromoButton(root = this) {
      const button = this._getPromoButton(root);
      if (!button || button.dataset.promoBtnBound === 'true') return;

      button.dataset.promoBtnBound = 'true';
      button.addEventListener('click', (event) => this._handlePromoButtonClick(event));
    }

    async _handlePromoButtonClick(event) {
      if (!this._shouldUseGiftAddToCart()) return;

      const button = event.currentTarget;
      if (!button || button.dataset.promoAction !== 'add-to-cart') return;

      event.preventDefault();

      if (this._promoButtonRequestInFlight) return;

      const cart = await this._fetchCart();
      if (!cart) return;

      if (this._isGiftInCart(cart)) {
        this._renderPromoButtonState(cart);
        return;
      }

      await this._addGiftVariantToCart(button);
    }

    async _addGiftVariantToCart(button) {
      const variantId = this._getGiftVariantId();
      if (!variantId) return;

      this._promoButtonRequestInFlight = true;
      this._setPromoButtonBusy(button, true);

      try {
        const response = await fetch(window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}cart/add.js`
          : '/cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          });

        if (!response.ok) {
          const addError = new Error(`Gift add failed with status ${response.status}`);
          addError.status = response.status;
          throw addError;
        }

        trackSmartCartClarityEvent('cart_add_success', {
          smartcart_source: 'conditional popup gift',
          smartcart_variant_id: variantId,
          smartcart_quantity: 1
        });

        const cart = await this._fetchCart();
        if (cart) {
          this._syncCartCount(cart);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this._renderCartMessages(this._getAdjustedCartTotal(cart));
          this._renderPromoButtonState(cart);
          this._showPromoFeedback('Gift added!');
        }
      } catch (err) {
        trackSmartCartClarityEvent('cart_add_failed', {
          smartcart_source: 'conditional popup gift',
          smartcart_status: err?.status || 'unknown',
          smartcart_variant_id: variantId,
          smartcart_error: err?.message || 'add failed'
        });
        console.error('Fifth Effect: Failed to add gift product from conditional popup', err);
        this._showPromoFeedback('Something went wrong. Please try again.');
      } finally {
        this._promoButtonRequestInFlight = false;
        this._setPromoButtonBusy(button, false);
      }
    }

    _syncCartCount(cart) {
      const cartCountElement = document.querySelector('cart-count');
      if (!cartCountElement) return;

      const itemCount = cart?.item_count || 0;
      const cartCountHTML = itemCount > 0
        ? `<div class='cart-count ${itemCount > 9 ? 'cart-count--ellipse' : ''}'><span aria-hidden='true'>${itemCount}</span></div>`
        : '';
      const mockNode = document.createElement('div');
      const newCartCountDiv = document.createElement('div');

      newCartCountDiv.id = 'NewCartCount';
      newCartCountDiv.innerHTML = cartCountHTML;
      mockNode.appendChild(newCartCountDiv);

      cartCountElement.dispatchEvent(new CustomEvent('update-nodes', {
        detail: { node: mockNode },
        bubbles: true
      }));
    }

    async _fetchCart() {
      try {
        const res = await fetch(window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}cart.js`
          : '/cart.js');

        if (!res.ok) {
          throw new Error(`Cart fetch failed with status ${res.status}`);
        }

        return await res.json();
      } catch (err) {
        console.error('Fifth Effect: Failed to fetch cart for conditional popup', err);
        return null;
      }
    }

    _getMessageElements(root = this) {
      return {
        belowEl: root.querySelector('[data-message-below]'),
        aboveEl: root.querySelector('[data-message-above]')
      };
    }

    _cacheMessageTemplates(root = this) {
      const { belowEl, aboveEl } = this._getMessageElements(root);

      [belowEl, aboveEl].forEach(el => {
        if (!el || el.dataset.messageTemplate) return;
        el.dataset.messageTemplate = el.innerHTML;
      });

      return { belowEl, aboveEl };
    }

    _renderCartMessages(cartTotal, root = this) {
      const { belowEl, aboveEl } = this._cacheMessageTemplates(root);
      const thresholdCents = parseInt(this.dataset.cartThresholdCents, 10) || 0;
      const isBelow = cartTotal < thresholdCents;
      const moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      const productTitle = this.dataset.giftProductTitle || '';
      const remainingCents = Math.max(0, thresholdCents - cartTotal);
      const formattedRemaining = formatMoney(remainingCents, moneyFormat);

      [belowEl, aboveEl].forEach(el => {
        if (!el) return;
        const template = el.dataset.messageTemplate || el.innerHTML;
        el.innerHTML = template
          .replace(/\{remaining_amount\}/g, formattedRemaining)
          .replace(/\{product_title\}/g, productTitle);
      });

      if (belowEl) belowEl.classList.toggle('hidden', !isBelow);
      if (aboveEl) aboveEl.classList.toggle('hidden', isBelow);
    }

    _setCartMessageFallback(root = this) {
      const { belowEl, aboveEl } = this._cacheMessageTemplates(root);

      if (belowEl) belowEl.classList.add('hidden');
      if (aboveEl) aboveEl.classList.add('hidden');
    }

    _renderCartHeadings(cartTotal, root = this) {
      const thresholdCents = parseInt(this.dataset.cartThresholdCents, 10) || 0;
      const isAbove = cartTotal >= thresholdCents;

      const defaultSub = root.querySelector('[data-default-subheading]');
      const aboveSub = root.querySelector('[data-above-subheading]');

      const defaultHead = root.querySelector('[data-default-heading]');
      const aboveHead = root.querySelector('[data-above-heading]');

      const activeSub = (isAbove && aboveSub) ? aboveSub : defaultSub;
      const activeHead = (isAbove && aboveHead) ? aboveHead : defaultHead;

      [defaultSub, aboveSub].forEach(el => {
        if (el) el.classList.toggle('hidden', el !== activeSub);
      });

      [defaultHead, aboveHead].forEach(el => {
        if (el) el.classList.toggle('hidden', el !== activeHead);
      });
    }

    async _syncPopupCartState(root = this) {
      if (this._isUpdatingCartMessages) return;

      this._isUpdatingCartMessages = true;

      try {
        const cart = await this._fetchCart();
        if (!cart) {
          this._setCartMessageFallback(root);
          this._renderPromoButtonState(null, root);
          return;
        }

        if (this.dataset.enableCartCondition === 'true') {
          const adjustedTotal = this._getAdjustedCartTotal(cart);
          this._renderCartMessages(adjustedTotal, root);
          this._renderCartHeadings(adjustedTotal, root);
        }

        this._renderPromoButtonState(cart, root);
      } finally {
        this._isUpdatingCartMessages = false;
      }
    }

    _observeCartChanges() {
      const cartCount = document.querySelector('cart-count');
      if (!cartCount) return;

      this._cartObserver = new MutationObserver(() => {
        this._syncPopupCartState();
      });

      this._cartObserver.observe(cartCount, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  // Register custom element
  if (!customElements.get('popup-conditional-promo')) {
    customElements.define('popup-conditional-promo', PopupConditionalPromo);
  }

  console.log('Fifth Effect: PopupConditionalPromo registered');

  // ─────────────────────────────────────────────────────
  // Alia Reward — auto-add + session handoff to Rebuy
  // ─────────────────────────────────────────────────────

  const ALIA_REWARD_SESSION_KEY = 'FifthEfffect-AliaRewardPending';
  let _aliaRewardInFlight = false;

  function getAliaRewardConfig() {
    const config = window.auroraTheme?.aliaReward;
    if (!config?.enabled || !config.variantId || !config.discountCode) return null;
    return config;
  }

  function normalizeDiscountCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function getEventDiscountCode(detail) {
    if (!detail) return '';
    return detail.discountCode || detail.discount_code || '';
  }

  function eventMatchesAliaReward(detail) {
    const config = getAliaRewardConfig();
    if (!config) return false;

    const eventCode = normalizeDiscountCode(getEventDiscountCode(detail));
    if (!eventCode) {
      console.warn('Fifth Effect: Alia reward — event missing discountCode; skipping auto-add.');
      return false;
    }

    return eventCode === normalizeDiscountCode(config.discountCode);
  }

  function trackAliaRewardEvent(eventName, details = {}) {
    if (typeof window.fifthFxTrackSmartCartEvent === 'function') {
      window.fifthFxTrackSmartCartEvent(eventName, details);
    }
  }

  async function applyAliaDiscountCode(discountCode) {
    const code = normalizeDiscountCode(discountCode);
    if (!code) return;

    try {
      const discountRes = await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
      console.log('Fifth Effect: Alia reward — discount endpoint responded', discountRes.status, discountRes.url);
      console.log('Fifth Effect: Alia reward — discount code "' + code + '" applied. Note: discounts only appear at checkout, NOT in the cart.');
    } catch (err) {
      console.error('Fifth Effect: Alia reward — failed to apply discount:', err);
    }
  }

  async function addAliaRewardProduct(event, sourceLabel = 'alia reward') {
    const config = getAliaRewardConfig();
    if (!config) {
      console.warn('Fifth Effect: Alia reward auto-add is disabled or misconfigured.');
      return false;
    }

    const { variantId, productHandle, discountCode } = config;

    try {
      sessionStorage.setItem(ALIA_REWARD_SESSION_KEY, JSON.stringify({
        variantId,
        productHandle,
        discountCode,
        sourceEvent: event?.type || 'alia:reward',
        triggeredAt: new Date().toISOString()
      }));
    } catch { /* private mode / quota */ }

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!addRes.ok) {
        const errorBody = await addRes.json().catch(() => ({}));
        trackAliaRewardEvent('cart_add_failed', {
          smartcart_source: sourceLabel,
          smartcart_status: addRes.status,
          smartcart_variant_id: variantId,
          smartcart_error: errorBody?.description || 'add failed'
        });
        console.error('Fifth Effect: /cart/add.js failed', addRes.status, errorBody);
        console.error('Fifth Effect: Verify Alia reward product variant in Theme Settings → Marketing:', variantId);
        try { sessionStorage.removeItem(ALIA_REWARD_SESSION_KEY); } catch { /* noop */ }
        return false;
      }

      trackAliaRewardEvent('cart_add_success', {
        smartcart_source: sourceLabel,
        smartcart_variant_id: variantId,
        smartcart_quantity: 1
      });
      console.log('Fifth Effect: Alia reward product added, session payload stored.');

      await applyAliaDiscountCode(discountCode);
      return true;
    } catch (err) {
      trackAliaRewardEvent('cart_add_failed', {
        smartcart_source: sourceLabel,
        smartcart_status: 'network',
        smartcart_variant_id: variantId,
        smartcart_error: err?.message || 'add failed'
      });
      console.error('Fifth Effect: Failed to add Alia reward product:', err);
      try { sessionStorage.removeItem(ALIA_REWARD_SESSION_KEY); } catch { /* noop */ }
      return false;
    }
  }

  document.addEventListener('alia:rewardClaimed', async (e) => {
    if (!eventMatchesAliaReward(e.detail)) return;
    if (_aliaRewardInFlight) return;
    _aliaRewardInFlight = true;

    await addAliaRewardProduct(e, 'alia reward');
    _aliaRewardInFlight = false;
  });

  window.handleAliaReturningBrownie = async function() {
    const config = getAliaRewardConfig();
    if (!config) {
      console.warn('Fifth Effect: Returning brownie — Alia reward is disabled or misconfigured.');
      return;
    }

    const { variantId, productHandle, discountCode } = config;

    try {
      const existing = sessionStorage.getItem(ALIA_REWARD_SESSION_KEY);
      if (!existing) {
        sessionStorage.setItem(ALIA_REWARD_SESSION_KEY, JSON.stringify({
          variantId,
          productHandle,
          discountCode,
          sourceEvent: 'alia:returningBrownie',
          triggeredAt: new Date().toISOString()
        }));
        console.log('Fifth Effect: Returning brownie — session payload created.');
      }
    } catch { /* private mode / quota */ }

    let cart = null;
    try {
      const cartRes = await fetch('/cart.js');
      if (cartRes.ok) {
        cart = await cartRes.json();
      }
    } catch (err) {
      console.error('Fifth Effect: Returning brownie — failed to fetch cart:', err);
    }

    const alreadyInCart = cart?.items?.some(item => Number(item.variant_id) === Number(variantId));

    if (!alreadyInCart) {
      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (!addRes.ok) {
          const errorBody = await addRes.json().catch(() => ({}));
          trackAliaRewardEvent('cart_add_failed', {
            smartcart_source: 'alia returning brownie',
            smartcart_status: addRes.status,
            smartcart_variant_id: variantId,
            smartcart_error: errorBody?.description || 'add failed'
          });
          console.error('Fifth Effect: Returning brownie — /cart/add.js failed', addRes.status, errorBody);
          return;
        }

        trackAliaRewardEvent('cart_add_success', {
          smartcart_source: 'alia returning brownie',
          smartcart_variant_id: variantId,
          smartcart_quantity: 1
        });
        console.log('Fifth Effect: Returning brownie — product added to cart.');
      } catch (err) {
        trackAliaRewardEvent('cart_add_failed', {
          smartcart_source: 'alia returning brownie',
          smartcart_status: 'network',
          smartcart_variant_id: variantId,
          smartcart_error: err?.message || 'add failed'
        });
        console.error('Fifth Effect: Returning brownie — failed to add product:', err);
        return;
      }
    } else {
      console.log('Fifth Effect: Returning brownie — product already in cart.');
    }

    await applyAliaDiscountCode(discountCode);

    const url = new URL(window.location.href);
    url.searchParams.delete('note');
    window.history.replaceState({}, '', url.toString());

    const smartCartDelay = alreadyInCart ? 300 : 1200;
    if (typeof window.fifthFxOpenSmartCartWhenReady === 'function') {
      window.fifthFxOpenSmartCartWhenReady(smartCartDelay, { source: 'alia:returningBrownie' });
    }

    setTimeout(() => {
      if (typeof window.injectAliaGiftAdvisory === 'function') {
        window.injectAliaGiftAdvisory();
      }
    }, 2000);
  };

})();
